import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import GatsbyImage from "gatsby-image"

import responsive from "@styles/responsive"

import Card from "@components/Card"
import GraphqlIcon from "@icons/GraphqlIcon"
import NetlifyIcon from "@icons/NetlifyIcon"

const techQuery = graphql`
  query {
    contentful: file(relativePath: { eq: "contentful-logo-small.png" }) {
      childImageSharp {
        fixed(width: 40, height: 40) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    gatsby: file(relativePath: { eq: "gatsby-icon.png" }) {
      childImageSharp {
        fixed(width: 40, height: 40) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`

const Tech = () => {
  const result = useStaticQuery(techQuery)
  const contentfulImage = result.contentful.childImageSharp.fixed
  const gatsbyImage = result.gatsby.childImageSharp.fixed

  return (
    <Card>
      <TechHeading>Built with</TechHeading>
      <TechList>
        <TechItem>
          <TechImage>
            <GatsbyImage fixed={contentfulImage}></GatsbyImage>
          </TechImage>
          <TechName>
            <a
              href="https://www.contentful.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contentful
            </a>
          </TechName>
        </TechItem>
        <TechItem>
          <TechImage>
            <GatsbyImage fixed={gatsbyImage}></GatsbyImage>
          </TechImage>
          <TechName>
            <a
              href="https://www.gatsbyjs.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GatsbyJS
            </a>
          </TechName>
        </TechItem>
        <TechItem>
          <TechImage>
            <GraphqlIcon />
          </TechImage>
          <TechName>
            <a
              href="https://graphql.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GraphQL
            </a>
          </TechName>
        </TechItem>
        <TechItem>
          <TechImage>
            <NetlifyIcon />
          </TechImage>
          <TechName>
            <a
              href="https://www.netlify.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Netlify
            </a>
          </TechName>
        </TechItem>
      </TechList>
    </Card>
  )
}

export default Tech

const TechHeading = styled.h4`
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: ${props => props.theme.colors.title};
  font-family: "Avenir Next W01";
  font-weight: 600;
  font-size: 2rem;
  padding-bottom: 1rem;
  margin-bottom: 2rem;

  ${responsive.sm} {
    font-size: 1.6rem;
  }
`

const TechList = styled.ul`
  width: 100%;
`

const TechItem = styled.li`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }
`

const TechImage = styled.div`
  display: block;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
`

const TechName = styled.p`
  font-size: 1.8rem;
  font-weight: 500;
  color: ${props => props.theme.colors.title};
  letter-spacing: 1px;
  margin-left: 1.6rem;

  ${responsive.sm} {
    font-size: 1.6rem;
  }
`
